import { render, staticRenderFns } from "./LibraryRegistration.vue?vue&type=template&id=90b8af52&scoped=true&"
import script from "@/views/LibraryRegistration/LibraryRegistration.ts?vue&type=script&lang=ts&"
export * from "@/views/LibraryRegistration/LibraryRegistration.ts?vue&type=script&lang=ts&"
import style0 from "@/views/LibraryRegistration/LibraryRegistration.scss?vue&type=style&index=0&id=90b8af52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b8af52",
  null
  
)

export default component.exports